import { Reveal } from '@/components/reveal';
import { CountUp } from '@/components/count-up';
import { useLocale } from '@/i18n/locale-context';

/** 解析 stat value 中的数字和前后缀，如 '< 150 MB' → { num: 150, prefix: '< ', suffix: ' MB' } */
function parseStatValue(raw: string): { num: number; prefix: string; suffix: string } {
  const match = raw.match(/([^\d]*)([\d.]+)(.*)/);
  if (!match) return { num: 0, prefix: raw, suffix: '' };
  return {
    num: parseFloat(match[2]),
    prefix: match[1],
    suffix: match[3],
  };
}

export function StatsSection() {
  const { t } = useLocale();

  return (
    <section id="stats" className="mx-auto w-full max-w-7xl px-6 py-20 sm:px-10 sm:py-28">
      <Reveal>
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-medium uppercase tracking-[0.18em] text-muted-foreground">
            {t.stats.eyebrow}
          </p>
          <h2 className="mt-4 text-2xl font-semibold tracking-tight sm:text-3xl">
            {t.stats.title}
          </h2>
          <p className="mt-3 text-sm leading-6 text-muted-foreground">
            {t.stats.description}
          </p>
        </div>
      </Reveal>

      <div className="mt-14 grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-6">
        {t.stats.items.map((item) => {
          const { num, prefix, suffix } = parseStatValue(item.value);
          return (
            <div
              key={item.label}
              className="card-shimmer relative flex h-full flex-col overflow-hidden rounded-xl border border-border/50 bg-card/30 p-5 transition-all duration-300 before:absolute before:top-0 before:left-1/2 before:-translate-x-1/2 before:h-[2px] before:w-12 before:bg-gradient-to-r before:from-transparent before:via-primary/50 before:to-transparent hover:-translate-y-1 hover:border-primary/40"
            >
              <p className="text-glow font-display text-3xl/none text-foreground">
                {num > 0 ? (
                  <CountUp end={num} prefix={prefix} suffix={suffix} />
                ) : (
                  <span>{item.value}</span>
                )}
              </p>
              <p className="mt-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">
                {item.label}
              </p>
              <p className="mt-1.5 flex-1 text-xs text-muted-foreground/80">{item.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
